(function (root, factory) {
  'use strict';

  if (typeof module === 'object' && module.exports) {
    module.exports = factory;
    return;
  }

  if (root.CentralSportExpressDeliveryBanner) return;
  root.CentralSportExpressDeliveryBanner = factory(root);
})(typeof window !== 'undefined' ? window : globalThis, function createExpressDeliveryBanner(runtime) {
  'use strict';

  var EVENT = 'cs:express-delivery:updated';
  var ELEMENT_NAME = 'cs-express-delivery-banner';

  function presentation(engine, data) {
    data = data || {};
    function rich(status, template, hasContent) {
      return {
        visible: hasContent === true || hasContent === 'true',
        status: status,
        template: template
      };
    }

    if (!engine || typeof engine.resolveDelivery !== 'function') {
      return rich('fallback', 'fallback', data.fallbackHasContent);
    }

    try {
      var result = engine.resolveDelivery({ product: { eligible: true, available: true } });
      var status = result && (result.state || result.status);

      if (result && result.visible === false) {
        return { visible: false, status: status || 'unavailable', template: null };
      }
      if (status === 'today' || status === 'same_day') {
        return rich('same_day', 'today', data.todayHasContent);
      }
      if (status === 'next_business_day') {
        return rich('next_business_day', 'next_business_day', data.nextHasContent);
      }
      if (status === 'weekend') return rich('weekend', 'weekend', data.weekendHasContent);
      if (status === 'holiday' || status === 'blackout') {
        return rich(status, status, data.nonOperationalHasContent);
      }
      return rich('fallback', 'fallback', data.fallbackHasContent);
    } catch (error) {
      return rich('fallback', 'fallback', data.fallbackHasContent);
    }
  }

  function setVisibility(element, visible) {
    var link = element.querySelector('[data-cs-express-delivery-banner-link]');
    element.hidden = !visible;
    if (visible) {
      element.removeAttribute('aria-hidden');
      element.removeAttribute('inert');
      if (link) link.removeAttribute('tabindex');
      return;
    }

    element.setAttribute('aria-hidden', 'true');
    element.setAttribute('inert', '');
    if (link) link.setAttribute('tabindex', '-1');
  }

  function update(element) {
    if (!element || typeof element.querySelector !== 'function') return;
    var result = presentation(runtime && runtime.CentralSportExpressDelivery, element.dataset || {});
    var richContent = element.querySelector('[data-cs-express-delivery-banner-rich-content]');

    setVisibility(element, result.visible);
    element.dataset.csStatus = result.status;
    if (result.template && richContent) {
      var template = element.querySelector('[data-cs-express-delivery-banner-template="' + result.template + '"]');
      if (template && template.content) richContent.replaceChildren(template.content.cloneNode(true));
      else richContent.replaceChildren();
    } else if (richContent) {
      richContent.replaceChildren();
    }
  }

  function register() {
    if (!runtime || !runtime.customElements || !runtime.HTMLElement || runtime.customElements.get(ELEMENT_NAME)) return;

    class ExpressDeliveryBanner extends runtime.HTMLElement {
      constructor() {
        super();
        this.csUpdate = () => update(this);
      }

      connectedCallback() {
        if (this.csListening) return;
        this.csListening = true;
        runtime.document.addEventListener(EVENT, this.csUpdate);
        update(this);
      }

      disconnectedCallback() {
        if (!this.csListening) return;
        runtime.document.removeEventListener(EVENT, this.csUpdate);
        this.csListening = false;
      }
    }

    runtime.customElements.define(ELEMENT_NAME, ExpressDeliveryBanner);
  }

  register();

  return Object.freeze({
    namespace: 'cs-express-delivery-banner',
    eventName: EVENT,
    presentation: presentation,
    setVisibility: setVisibility,
    update: update
  });
});
